import { API } from "config/API"

export const getCurrentCashOperationDay = async () => {
  const response = await API.get("/cash-operation-days/current")
  return response
}

export const getCashOperationDays = async (filters = {}) => {
  const response = await API.get("/cash-operation-days", { params: filters })
  return response
}

export const openCashOperationDay = async (payload) => {
  const response = await API.post("/cash-operation-days/open", payload)
  return response
}

export const closeCashOperationDay = async (payload = {}) => {
  const response = await API.post("/cash-operation-days/close", payload)
  return response
}

export const reopenCashOperationDay = async (payload = {}) => {
  const response = await API.post("/cash-operation-days/reopen", payload)
  return response
}
